import React from 'react';
// template components
import Col from '@nmx/template/dist/componentLibrary/foundations/Grid/Col';
import Row from '@nmx/template/dist/componentLibrary/foundations/Grid/Row';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';
import WidowBlock from '@nmx/template/dist/componentLibrary/components/WidowBlock';
// icons
import PaperMoneyStack from '@nmx/template/dist/componentLibrary/foundations/Icon/icons/illustrative/lightTheme/PaperMoneyStack';
import PaperWithDollarSignAndBarChart from '@nmx/template/dist/componentLibrary/foundations/Icon/icons/illustrative/lightTheme/PaperWithDollarSignAndBarChart';
import TwoPeopleTwoWordBubbles from '@nmx/template/dist/componentLibrary/foundations/Icon/icons/illustrative/lightTheme/TwoPeopleTwoWordBubbles';
// native components
import UnderstandingProductGrouping from '../../../../components/understandingProductGrouping/understandingProductGrouping';
// styles
import { LinkStyled } from './styles';

export const ITEMS = [
  {
    id: 'retirement-planning-we-can-help',
    icon: PaperMoneyStack,
    title: (<>Even if you haven&#39;t been a super saver, we <WidowBlock>can help.</WidowBlock></>),
    contentAs: 'div',
    content: (
      <Typography
        align='left'
        disableBottomPadding>
        Our financial advisors will help you make the most of your money, no matter how much you have, with a plan tailored to you and your retirement goals.
      </Typography>
    ),
  },
  {
    id: 'retirement-planning-we-will-get-you-there',
    icon: PaperWithDollarSignAndBarChart,
    title: (<>If you&#39;re not a financial pro, we&#39;ll get <WidowBlock>you there.</WidowBlock></>),
    contentAs: 'div',
    content: (
      <Typography
        align='left'
        disableBottomPadding>
        We&#39;ll design a plan to help mitigate financial risk and create the right amount of income so you can have the retirement you always dreamed of.
      </Typography>
    ),
  },
  {
    id: 'retirement-planning-easy-to-talk',
    icon: TwoPeopleTwoWordBubbles,
    title: (<>We make it easy to talk about <WidowBlock>your finances.</WidowBlock></>),
    contentAs: 'div',
    content: (
      <Typography
        align='left'
        disableBottomPadding>
        We&#39;re expert listeners and our conversations will be free of any jargon or judgment. No matter what your situation is, we&#39;re here to show you the right financial steps to take.
      </Typography>
    ),
  },
];

export default () => {
  return (
    <UnderstandingProductGrouping
      id='retirement-planning'
      backgroundVariant='lightB'
      headingText={<>Real talk about <WidowBlock>retirement planning.</WidowBlock></>}
      cardDataArray={ITEMS}
      secondaryContent={
        <Row align='center'>
          <Col align='center'>
            <LinkStyled
              id='retirement-planning-understanding-product-cta'
              variant='buttonLinkPrimary'
              linkUrl='/financial-planning/'
              ariaLabel='Learn more about financial planning'>
              See more on planning
            </LinkStyled>
          </Col>
        </Row>
      }
    />
  );
};
